<template>
  <div :class="isMobile ? 'footer-m' : 'footer'">
    <div class="footer-content">
      <div class="logo">
        <img src="./../assets/logo-blue.png" />
        <div class="subtitle">赋予机器嗅觉感知世界</div>
      </div>
      <div class="product-list" v-for="(item, index) in contentList" :key="index">
        <span class="product-list-one-title">{{item.title}}</span>
        <ul>
          <li v-for="(obj, i) in item.list" :key="i" class="product-list-one-name" @click="jumpTo(item, index, i)">{{obj.name}}</li>
        </ul>
      </div>

      <el-row>
        <el-col :span="8">
          <ul class="messlist">
            <li>
              <img class="icon" src="../assets/homeIcon/postcode.png"/>
              <span class="text">邮编：528000</span>
            </li>
            <li>
              <img class="icon" src="../assets/homeIcon/phone-small.png"/>
              <span class="text">电话：15255615034/0757-85335951</span>
            </li>
            <li>
              <img class="icon" src="../assets/homeIcon/email.png"/>
              <span class="text">邮箱：xuefeng@aisensing.cn</span>
            </li>
            <li>
              <img class="icon" src="../assets/homeIcon/location.png"/>
              <span class="text">地址：佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801</span>
            </li>
            <li><el-button type="text" @click="clickBtn" class="btnLink">艾感网络聚合索引</el-button></li>
          </ul>
        </el-col>
      </el-row>
      <div class="qrcode-list">
          <ul>
            <li class="li-code">
              <img class="code" src="./../assets/icon/code01.jpg" alt="" />
              <span class="code-text">产品咨询</span>
            </li>
            <li class="li-code">
              <img class="code" src="./../assets/icon/code02.jpg" alt="" />
              <span class="code-text">产品手册</span>
            </li>
            <li class="li-code">
              <img class="code" src="./../assets/icon/code03.jpg" alt="" />
              <span class="code-text">公众号</span>
            </li>
            <li class="li-code">
              <img class="code" src="./../assets/icon/code04.jpg" alt="" />
              <span class="code-text">抖音号</span>
            </li>
          </ul>
      </div>
    </div>
    <div class="icp">
      <a href="https://beian.miit.gov.cn" target="_blank">艾感科技（广东）有限公司 粤ICP备18012156号</a>
    </div>

    <el-dialog
      title="艾感网络聚合索引列表"
      :visible.sync="dialogVisible"
      :width="isMobile ? '95%' : ''"
      class="dialog"
      :before-close="handleClose">
      <div>
        <div style="margin-top: 15px;">
          <el-input placeholder="请输入编码" v-model="inputValue" size="mini" class="linkInput" id="enterCode">
          </el-input>
          <el-button size="mini" @click="searchLink">搜索</el-button>
        </div>
        <el-tabs v-model="activeTab" v-show="linkIsShow" class="dialogContent" type="border-card">
          <el-tab-pane label="网站聚合索引列表" name="0">
            <div class="linkList" id="linkList" >
              <span v-for="item in linkList" class="oneLink" :key="item.name"><a target="_blank" :href="item.url">{{item.name}}</a></span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="流量统计" name="1">
            <el-table
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop=name
                label="页面"
                width="220">
                <template slot-scope="scope">
                  <div >{{ scope.row.name }}</div>
                  <div class="table-subname">{{ scope.row.subname }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="hits"
                label="总流量">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
import arrJson from '@/utils/arrJson'

export default {
  name: 'Foot',
  props: {
    msg: String
  },
  data() {
    return {
      isMobile: window.innerWidth < 780,
      dialogVisible: false,
      inputValue: "",
      linkIsShow: false,
      activeTab: "0",
      tableData: [],
      linkList: arrJson.footLinkList,
      contentList: [
        {
          title: '产品中心',
          list: [
            { name: '气体传感器', url: '#' }, 
            { name: '传感器模组', url: '#' },
            { name: '嗅觉芯片', url: '#' },
            { name: '监测系统', url: '#' },
          ]
        },
        {
          title: "解决方案",
          list: [
            { name: "智能家居", url: "#" },
            { name: "环境监测", url: "#" },
            { name: "康养护理", url: "#" },
            { name: "工业安全", url: "#" },
            { name: "标准化气体", url: "#" }
          ]
        },
        {
          title: "应用领域",
          list: [
            { name: "环境监测", url: "#" },
            { name: "智能家居", url: "#" },
            { name: "智能监护", url: "#" },
            { name: "食品安全", url: "#" },
            { name: "汽车电子", url: "#" },
            { name: "具身智能", url: "#" },
            { name: "消费电子", url: "#" },
            { name: "石油化工", url: "#" }
          ]
        },
        {
          title: "走进艾感",
          list: [
            { name: "公司概况", url: "#" },
            { name: "研发实力", url: "#" },
            { name: "发展历程", url: "#" },
            { name: "企业文化", url: "#" },
            { name: "科研成果", url: "#" },
            { name: "资质和荣誉", url: "#" },
            { name: "合作伙伴", url: "#" }
          ]
        },
        {
          title: "新闻动态",
          list: [
            { name: "公司动态", url: "#" },
            { name: "行业方案", url: "#" },
            { name: "视频速览", url: "#" }
          ]
        },
        {
          title: "加入我们",
          list: [
            { name: "招聘岗位", url: "#" },
            { name: "联系我们", url: "#" },
            { name: "企业地址", url: "#" }
          ]
        }
      ],
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
    this.getHits()
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
    this.removeListen()
  },
  methods: {
    handleClose(done) {
      this.linkIsShow = false
      this.inputValue = ""
      this.removeListen()
      done()
    },
    clickBtn() {
      this.dialogVisible = true
      this.addListen()
    },
    enterEvent(event){
      if (event.key === 'Enter') {
        this.searchLink(true)
      }
    },
    addListen() {
      document?.addEventListener('keydown', this.enterEvent)
    },
    removeListen() {
      document?.removeEventListener('keydown', this.enterEvent)
    },
    getHits() {
      this.tableData = [{
        name: '官网',
        subname: '(2023-10-12开始统计)',
        hits: 6192
      }, {
        name: '艾感污染源监测',
        subname: '（原瀚蓝恶臭）',
        hits: 173
      }, {
        name: '艾感室内气体监测设备',
        subname: '(样机展示)',
        hits: 1387
      }, {
        name: '大气污染智能化监控',
        hits: 371
      }, {
        name: '空气监测平台',
        subname: '原南庄镇大气污染监测',
        hits: 1032
      }, {
        name: 'feelT智能运动鞋垫',
        hits: 378
      }, {
        name: '艾感室内空气监测',
        subname: '(手持设备)',
        hits: 352
      // }, {
      //   name: '生产跟踪系统',
      //   hits: 84
      }]
    },
    searchLink(type) {
      if(this.inputValue === "Aigan") {
        this.linkIsShow = true
      } else {
        if(type && this.inputValue === ""){
          return false
        }
        this.isMobile ? 
        this.$dialog.alert({
          message: '编码错误，请重新输入',
        }) :
        this.$message({
          message: '编码错误，请重新输入',
          type: 'warning'
        });
      }
    },
    jumpTo(item, index, i) {
      console.log("index", index, "this.$route.path", this.$route.path)
      if(item.title=="产品中心"){
        window.sessionStorage.setItem('productClassId', i+1);
        if(this.$route.path === '/product'){
          location.reload()
        }else{
          this.$router.push({ path: '/product' })
        }
      }else if(item.title=="解决方案"){
        window.sessionStorage.setItem('productClassId', i+1);
        if(this.$route.path === '/plan'){
          location.reload()
        }else{
          this.$router.push({ path: '/plan' })
        }
      }else if(item.title=="应用领域"){
        window.sessionStorage.setItem('placeId', i);
        if(this.$route.path === '/place'){
          location.reload()
        }else{
          this.$router.push({ path: '/place' })
        }
      }
    },
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  }
}
</script>


<style scoped lang="less">
.footer{
  background: #384C5C;
  color: #fefefe;
  .footer-content{
    background: #384C5C;
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px 0 0;
    text-align: left;
    position: relative;
  }
  .logo{
    display: inline-block;
    vertical-align: middle;
    width: 200px;
    margin-right: 60px;
    img{
      width: 100%;
      display: inline-block;
    }
    .subtitle{
      color: #3abde7;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
    }
  }
  .messlist{
    margin-top: -130px;
    .icon{
      width: 20px;
      height: 20px;
      padding: 0 12px 0 0;
      display: inline-block;
      vertical-align: bottom;
    }
    .text{
      display: inline-block;
      vertical-align: bottom;
      line-height: 20px;
    }
  }
  .qrcode-list{
    position: absolute;
    right: 100px;
    bottom: 28px;
    .li-code{
      display: inline-block;
      margin: 0 20px;
    }
    .code{
      width: 70px;
      height: 70px;
    }
    .code-text{
      display: block;
      text-align: center;
      line-height: 8px;
      font-size: 12px;
    }
  }
  .product-list{
    display: inline-block;
    vertical-align: top;
    margin: 0 0 0 80px;
    font-size: 14px;
    .product-list-one-title{
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      display: block;
    }
    .product-list-one-name{
      color: #ffffff60;
      text-align: center;
    }
  }
  .el-divider--vertical{
    margin: 0 16px;
  }
  .el-row{
    margin: 30px 0;
  }
  .dialogContent{
    margin-top: 20px;
  }
  .icp{
    line-height: 40px;
    color: #fff;
    font-size: 16px;
    background: #00D0FF;
    text-align: center;
  }
  .title{
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    font-size: 13px;
    line-height: 34px;
    list-style: none;
    color: #ffffffc9;
    text-align: left;
    word-break: break-all;
  }
  .li-code{
    text-align: center;
  }
  .btnLink{
    color: #ffffffc9;
  }
  .dialog{
    text-align: left;
    /deep/.el-dialog{
      width: 620px !important;
    }
    .linkList{
      margin: 10px 0;
      text-align: left;
    }
    .linkList .oneLink {
      display: block;
      font-size: 14px;
      line-height: 30px;
      color: #0e2a3c;
      a{
        color: #00000099;
      }
    }
    .link-body{
      margin: 0 0 50px;
    }
    .linkInput{
      display: inline-block;
      width: 200px;
    }
    .table-subname{
      color: #a5a5a5;
      font-size: 12px;
      line-height: 14px;
    }
  }
}

  //移动端
    .footer-m{
      font-size: 0.6rem;
      color: #ebf0fa;
      line-height: 0.68rem;
      .footer-content{
        background: #384C5C;
        padding: 0.4rem;
        .subtitle{
          line-height: 1.4rem;
          color: #3abde7;
          font-size: 0.4rem;
          text-align: center;
        }
        .logo{
          width: 86%;
          margin: 0.2rem auto;
        }
        img{
          width: 60%;
          margin: 0 auto;
          display: block;
        }
        .product-list{
          margin: 0.2rem 0.1rem 0 0;
          padding-right: 0.1rem;
          font-size: 0.36rem;
          color: #ffffffd4;
          display: inline-block;
          vertical-align: top;
          border-right: 0.02rem solid #ffffff63;
          line-height: 0.4rem;
          .el-divider--vertical{
            margin: 0 0.24rem;
          }
          .product-list-one-name{
            display: none;
          }
        }
        .el-row{
          .messlist{
            padding: 0;
          }
          li{
            .icon{
              width: 0.4rem;
              height: 0.4rem;
              display: inline-block;
              margin-right: 0.2rem;
            }
            .text{
              color: #fff;
              font-size: 0.3rem;
            }
          }
          .el-col{
            width: 100%;
            margin: 0;
          }
          // .el-button{
          //   font-size: 0.4rem;
          //   line-height: 0.78rem;
          // }
        }
        .qrcode-list{
          .li-code{
            display: inline-block;
          }
            .code{
              width: 2rem;
              height: 2rem;
              display: inline-block;
              vertical-align: middle;
              margin: 0.4rem 0.12rem 0.1rem;
            }
            .code-text{
              font-size: 0.36rem;
              display: block;
              text-align: center;
            }
          }
        .btnLink{
          color: #3abde7;
        }
      }
      .dialogContent{
        margin-top: 0.5rem;
      }
      .icp{
        font-size: 0.34rem;
        line-height: 0.8rem;
        background: #00D0FF;
        text-align: center;
      }
      .dialog{
        .linkInput{
          width: 80% !important;
        }
        /deep/ .el-dialog__title{
          font-size: 0.4rem;
          line-height: 1rem;
        }
        /deep/ .el-dialog__body{
          padding: 0.2rem 0.2rem;
        }
        /deep/ .el-dialog__headerbtn{
          font-size: 0.4rem;
        }
        /deep/ .el-input--mini{
          font-size: 0.3rem;
          .el-input__inner {
            line-height: 1rem;
            height: 1rem;
            font-size: 0.3rem;
          }
        }
        .el-button--mini {
          font-size: 0.3rem;
          line-height: 0.6rem;
          padding: 0.2rem 0.4rem;
        }
        .linkList {
          .oneLink[data-v-02065d92] {
            font-size: 0.4rem;
            line-height: 1rem;
            display: block;
          } 
        }
        .table-subname{
          font-size: 0.34rem;
          color: #9a9a9a;
          line-height: 0.42rem;
        }
      }
    }



</style>
